<template>
    <v-container fluid>
        <v-row>
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="4"
                lg="6"
                md="6"
                sm="4"
            >
                <h3>Dashboard</h3>
            </v-col>
        </v-row>

        <v-row>
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="4"
                lg="6"
                md="6"
                sm="4"
            >
                <br />
            </v-col>
        </v-row>

        <v-row>
            <v-col 
                cols="12"
                lg="2"
                md="6"
                sm="12"
            >
                <v-card>
                    <v-card-title class="text-h6 background-color-needs-buy d-flex justify-space-between">
                        
                        <div>
                            <v-icon left class="icon">mdi mdi-package-variant-closed</v-icon>
                            <label class="title">Products To Order</label>
                        </div>

                    </v-card-title> 
                    <v-card-text 
                        class="card-content"
                    >
                        <div class="value">{{ qtyProductsToOrder }}</div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col 
                cols="12"
                lg="2"
                md="6"
                sm="12"
            >
                <v-card>
                    <v-card-title class="text-h6 background-color-waiting-order d-flex justify-space-between">
                        
                        <div>
                            <v-icon left class="icon">mdi mdi-timer-pause-outline</v-icon>
                            <label class="title">Jobs On Hold- Awaiting Order</label>
                        </div>

                    </v-card-title> 
                    <v-card-text 
                        class="card-content"
                    >
                        <div class="value">{{ qtyAwaitingOrder }}</div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col 
                cols="12"
                lg="2"
                md="6"
                sm="12"
            >
                <v-card>
                    <v-card-title class="text-h6 background-color-in-progress d-flex justify-space-between">
                        
                        <div>
                            <v-icon left class="icon">mdi mdi-progress-clock</v-icon>
                            <label class="title">Orders In Progress</label>
                        </div>

                    </v-card-title> 
                    <v-card-text 
                        class="card-content"
                    >
                        <div class="value">{{ qtyOrdersInProgress }}</div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col 
                cols="12"
                lg="2"
                md="6"
                sm="12"
            >
                <v-card>
                    <v-card-title class="text-h6 background-color-in-progress d-flex justify-space-between">
                        
                        <div>
                            <v-icon left class="icon">mdi mdi-package-variant-closed-check</v-icon>
                            <label class="title">Products That Arrived</label>
                        </div>

                    </v-card-title> 
                    <v-card-text 
                        class="card-content"
                    >
                        <div class="value">{{ qtyProductsArrived }}</div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col 
                cols="12"
                lg="2"
                md="6"
                sm="12"
            >
                <v-card>
                    <v-card-title class="text-h6 background-color-late d-flex justify-space-between">
                        
                        <div>
                            <v-icon left class="icon">mdi mdi-order-bool-descending-variant</v-icon>
                            <label class="title">Late Orders</label>
                        </div>

                    </v-card-title> 
                    <v-card-text 
                        class="card-content"
                    >
                        <div class="value">{{ qtyLateOrders }}</div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col 
                style="margin-top: 30px;"
                cols="12"
                lg="12"
                md="12"
                sm="12"
            >
                <v-tabs vertical fixed-tabs>
                    <v-tab @click="getRegisters">
                        Qty
                    </v-tab>
                    <v-tab @click="getRegisters">
                        Value
                    </v-tab>

                    <!-- BY QTY -->
                    <v-tab-item key="1">

                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <BarChart
                                    ref="chartStatusQtd"
                                    :chartId="'dashboardSalesStatusByQtd'"
                                    :chartData="dashboardSalesStatusByQtd"
                                />
                            </v-col>
                        </v-row>
                        
                    </v-tab-item>

                    <!-- BY VALUE -->
                    <v-tab-item key="2">

                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <BarChart
                                    ref="chartStatusValue"
                                    :chartId="'dashboardSalesStatusByValue'"
                                    :chartData="dashboardSalesStatusByValue"
                                />
                            </v-col>
                        </v-row>

                    </v-tab-item>
                </v-tabs>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
    import Helpers from '@/utilities/Helpers';
    import BarChart from '@/components/Graphics/Bar.vue';

    export default ({

        mixins: [Helpers],

        components: {
            BarChart
        },

        data: () => ({

            filter: {
                fastSearch: ''
            },

            qtyProductsToOrder: 0,
            qtyAwaitingOrder: 0,
            qtyOrdersInProgress: 0,
            qtyProductsArrived: 0,
            qtyLateOrders: 0,

            dashboardSalesStatusByQtd: {
				labels: [],
				datasets: [{
                    label: '',
                    backgroundColor: '',
                    data: []
                }]
			},

            dashboardSalesStatusByValue: {
				labels: [],
				datasets: [{
                    label: '',
                    backgroundColor: '',
                    data: []
                }]
			},

            listMonth: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ],

            loading: false,            
        }),

        methods: {

            async getRegisters() {
                this.showLoading();
                await this.setGraphByStatus();
                this.hideLoading();
            },
            
            generateColor(){
                return `#${Math.floor(Math.random()*16777215).toString(16)}`;
            },

            async setGraphByStatus() {

                const orderFilterRequest = {
                    idOrder: 0,
                    idServiceProject: 0,
                    idProduct: 0,
                }

                const listOrders = await this.$store.dispatch("warehouseModule/OrdersList", orderFilterRequest);
                const listUniqueId = [...new Set(listOrders.map((item) => item.idProduct))];
                const listUniqueStatus = [...new Set(listOrders.map((item) => item.statusDescription))];
                const listQBPurchaseOrders = await this.$store.dispatch("qbPurcharseOrderModule/List");

                this.qtyProductsToOrder = listUniqueId.length;
                this.qtyAwaitingOrder = listOrders.filter(order => order.status == 1).length;
                this.qtyOrdersInProgress = listOrders.filter(order => order.status == 2).length;
                this.qtyProductsArrived = listQBPurchaseOrders.filter(order => order.status == 5).length;
                this.qtyLateOrders = listOrders.filter(order => order.status == 3).length;
                
                this.dashboardSalesStatusByQtd.datasets = [];
                this.dashboardSalesStatusByValue.datasets = [];

                listUniqueStatus.forEach(item => {

                    let qtdData = [];
                    let valueData = [];
                    let statusDescription = "";
                    listOrders.filter(dash => dash.statusDescription == item).forEach (dash => {
                        qtdData.push(dash.qtd);
                        valueData.push(dash.value);
                        statusDescription = dash.statusDescription;
                    });

                    this.dashboardSalesStatusByQtd.datasets.push({
                        label: statusDescription,
                        backgroundColor: this.generateColor(),
                        data: qtdData
                    });

                    this.dashboardSalesStatusByValue.datasets.push({
                        label: statusDescription,
                        backgroundColor: this.generateColor(),
                        data: valueData
                    });
                });

                if (this.$refs.chartStatusQtd) {
                    this.$refs.chartStatusQtd.$refs.chart._data._chart.config._config.data.labels = this.listMonth;
                    this.$refs.chartStatusQtd.$refs.chart._data._chart.config._config.data.datasets = this.dashboardSalesStatusByQtd.datasets;
                    this.$refs.chartStatusQtd.$refs.chart._data._chart.update("none");
                }

                if (this.$refs.chartStatusValue) {
                    this.$refs.chartStatusValue.$refs.chart._data._chart.config._config.data.labels = this.listMonth;
                    this.$refs.chartStatusValue.$refs.chart._data._chart.config._config.data.datasets = this.dashboardSalesStatusByValue.datasets;
                    this.$refs.chartStatusValue.$refs.chart._data._chart.update("none");
                }
            },

        },

        async created() {
            this.showLoading();
            await this.getRegisters();
            this.hideLoading();
        },
    })
</script>

<style scoped>

    .card-content {
        text-align: center;
        height: 100px;
    }

    .value {
        color: var(--color__main) !important;
        font-weight: bold !important; 
        font-size: 20px !important;
        align-content: center;
        text-align: center;
        height: 100px;
    }

    .icon {
        color: white !important;
    }

    .title {
        color: white !important;
        font-size: 17px;
    }

    .background-color-needs-buy {
        background-color: var(--color__alert);
    }

    .background-color-late {
        background-color: var(--color__red);
    }

    .background-color-in-progress {
        background-color: var(--color__main);
    }

    .background-color-waiting-order {
        background-color: var(--color__status_pending);
    }

</style>